import type { ReactNode } from 'react'
import { Dialog } from 'radix-ui'

export function DialogShell({
  title,
  open = true,
  onClose,
  isSubmitting,
  error,
  onSubmit,
  children,
}: {
  title: string
  open?: boolean
  onClose: () => void
  isSubmitting: boolean
  error: string | null
  onSubmit: () => void
  children: ReactNode
}) {
  return (
    <Dialog.Root open={open} onOpenChange={o => { if (!o) onClose() }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-5 w-[420px] shadow-xl">
          <Dialog.Title className="text-base font-semibold">{title}</Dialog.Title>
          <div className="mt-4 flex flex-col gap-3 text-sm">
            {children}
            {error && <p className="text-red-600 text-xs">{error}</p>}
            <div className="flex justify-end gap-2 mt-2">
              <button type="button" onClick={onClose} className="px-3 py-1.5 border rounded" disabled={isSubmitting}>Anuluj</button>
              <button type="button" onClick={onSubmit} className="px-3 py-1.5 bg-sky-600 text-white rounded disabled:opacity-50" disabled={isSubmitting}>
                {isSubmitting ? 'Zapisywanie...' : 'Zapisz'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
